import { useFormContext } from 'react-hook-form';

import { VChip, VFlex } from '@/package';

import type { TaskCreateFormType } from './type';

export const TaskWorkerList = ({ readOnly }: { readOnly: boolean }) => {
  const { watch, setValue } = useFormContext<TaskCreateFormType>();
  const worker = watch('worker');

  return (
    <VFlex className="flex-1 overflow-y-auto">
      <VFlex className="h-fit flex-wrap gap-1">
        {worker?.map(user => (
          <VChip
            key={user.id}
            onDelete={() => {
              setValue(
                'worker',
                worker?.filter(w => w.id !== user.id),
                {
                  shouldDirty: true,
                  shouldTouch: true,
                  shouldValidate: true,
                },
              );
            }}
            disabled={readOnly}
          >
            {user.email}
          </VChip>
        ))}
      </VFlex>
    </VFlex>
  );
};

TaskWorkerList.displayName = 'TaskWorkerList';
